import React from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import type { RootState } from '../../store';
import clsx from 'clsx';

export default function SessionSummaryCard() {
  const summary = useSelector((state: RootState) => state.liveSession.summary);

  if (!summary) return null;

  const scoreColor = summary.averageScore >= 80
    ? 'text-emerald-600 dark:text-emerald-400'
    : summary.averageScore >= 60
    ? 'text-yellow-600 dark:text-yellow-400'
    : 'text-red-500 dark:text-red-400';

  const minutes = Math.floor(summary.durationS / 60);
  const seconds = Math.round(summary.durationS % 60);

  return (
    <div className="card max-w-md mx-auto text-center">
      <h2 className="text-xl font-bold text-gray-900 dark:text-white mb-6">Session Complete</h2>

      <div className="grid grid-cols-2 gap-4 mb-6">
        <div className="bg-gray-50 dark:bg-gray-800/50 rounded-xl p-4">
          <p className={clsx('text-3xl font-bold', scoreColor)}>
            {Math.round(summary.averageScore)}
          </p>
          <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">Average Score</p>
        </div>
        <div className="bg-gray-50 dark:bg-gray-800/50 rounded-xl p-4">
          <p className="text-3xl font-bold text-emerald-600 dark:text-emerald-400">
            {summary.totalTurns}
          </p>
          <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">Turns Practiced</p>
        </div>
      </div>

      <div className="mb-6">
        <p className="text-sm text-gray-500 dark:text-gray-400 mb-2">Duration: {minutes}m {seconds}s</p>
        {summary.rulesPracticed.length > 0 && (
          <div className="flex flex-wrap gap-2 justify-center">
            {summary.rulesPracticed.map((rule) => (
              <span
                key={rule}
                className="badge bg-emerald-50 dark:bg-emerald-500/10 text-emerald-600 dark:text-emerald-400 border border-emerald-200 dark:border-emerald-500/30"
              >
                {rule}
              </span>
            ))}
          </div>
        )}
      </div>

      <div className="flex gap-3 justify-center">
        <Link to="/dashboard" className="btn-secondary text-sm px-6 py-2">
          Dashboard
        </Link>
        <Link to="/practice" className="btn-primary text-sm px-6 py-2">
          Practice Mode
        </Link>
      </div>
    </div>
  );
}
